import { Component, OnDestroy, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-centers-new-center-dashboard',
  templateUrl: './centers-new-center-dashboard.component.html',
  styleUrls: ['./centers-new-center-dashboard.component.scss']
})
export class CentersNewCenterDashboardComponent implements OnInit, OnDestroy {

  centerTypeList;
  currencies;
  getCenterTypeListSubscription: Subscription;
  getCenterCurrenciesSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private centersCentersService: CentersCentersService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getCenterTypeList();
    this.getCenterCurrencies();
  }

  private getCenterTypeList() {
    this.getCenterTypeListSubscription = this.centersCentersService.getCenterTypes().pipe(
      tap(res => this.centerTypeList = res)
    ).subscribe();
  }

  private getCenterCurrencies() {
    this.getCenterCurrenciesSubscription = this.centersCentersService.getCenterCurrencies().pipe(
      tap(res => this.currencies = res)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-store-alt', 'stores-page.new store', '/centers', [new BRoute('stores-page.store locator', '/account'), new BRoute('stores-page.new store')]));
  }

  ngOnDestroy() {
    if (this.getCenterTypeListSubscription) { this.getCenterTypeListSubscription.unsubscribe(); }
    if (this.getCenterCurrenciesSubscription) { this.getCenterCurrenciesSubscription.unsubscribe(); }
  }
}
